<template>
  <div class="course-mooc">
    <div class="container-top">
      <div class="main-title">“以考代修”课程</div>
      <div class="more-btn" @click="handleMore" v-if="homeCourseList && homeCourseList.length > 0">
        <TrangleButton />
      </div>
    </div>
    <div class="module-content">
      <div class="course-card-list" v-if="homeCourseList && homeCourseList.length > 0">
        <div
          class="course-card"
          :class="{
            active: index == activeIndex
          }"
          v-for="(course, index) in homeCourseList"
          :key="course.id"
          @mouseover="activeIndex = index"
          @click="goDetail(course)"
        >
          <div class="course-img">
            <img :src="course.course_cover_url || require('@/assets/images/common/course_cover.png')" alt="" />
          </div>
          <div class="course-info">
            <div class="course-name">{{ course.course_name }}</div>
            <div class="teacher-name">{{ course.lecturer }}</div>
            <div class="orga-name">{{ course.organ_name }}</div>
            <div class="btn"></div>
          </div>
        </div>
      </div>
      <div v-else class="no-data">
        <Empty />
      </div>
    </div>
  </div>
</template>
<script>
import CourseCard from './CourseCard.vue'
import CardHeader from '@/pages/components/CardHeader'
import Live from './Live.vue'
import { Empty } from 'zhs-components'
import UserCard from './UserCard/index'
import TrangleButton from './TrangleButton.vue'
import { ElMessage } from 'element-plus'

export default {
  components: {
    CourseCard,
    Live,
    Empty,
    CardHeader,
    UserCard,
    TrangleButton
  },
  props: {
    courseType: Number,
    menu: Object,
    userInfo: {
      type: Object,
      default: null
    },
    zhsRole: {
      type: Number || String,
      default: 0
    },
    isTop: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.getAuth()
    this.getTypeList()
  },
  watch: {
    typeId: {
      handler(val) {
        this.getHomeCourseList()
      },
      immediate: true
    }
  },
  data() {
    return {
      homeCourseList: [],
      courseCategorys: [],
      classId: undefined,
      authType: 0,
      typeList: [],
      hiddenMoreClass: true,
      typeId: '',
      activeIndex: 0
    }
  },
  methods: {
    goDetail(item) {
      if (this.authType == 2 && !this.userInfo) {
        handleLogin()
        return
      }
      if (item.course_url) {
        window.open(item.course_url)
      } else {
        ElMessage.warning('暂未配置地址！')
      }
    },
    handleMore() {
      window.open(
        `/courseList.html?type=2&name=${this.menu.module_name}&menuId=${this.menu.menu_id}`
      )
    },
    async getHomeCourseList() {
      const homeCourse = await this.$http.getHomeSpoc({
        num: this.menu.num,
        menu_id: this.menu.menu_id,
        classify_id: this.typeId
      })
      console.log(homeCourse, 'ioioipipoipoiopi参数')
      this.homeCourseList = homeCourse
    },
    async getAuth() {
      const res2 = await this.$http.getConfigList()
      this.authType = res2.find(item => item.code == '10401')
        ? res2.find(item => item.code == '10401').auth_type
        : 0
    },
    async getTypeList() {
      const res = await this.$http.getCourseType({
        menu_id: this.menu.menu_id
      })
      this.typeList = res
      // if (res && res.length) {
      //   this.typeId = res[0].id
      // }
    },
    searchCourseList(id) {
      this.typeId = id
    }
  }
}
</script>

<style lang="scss" scoped>
.animate-wrap {
  .animated-card {
    opacity: 0;
    transform: translateX(-20px);
  }
  &.visible {
    .animated-card {
      animation: slideIn 0.5s forwards;
      animation-delay: var(--delay, 0.7s);
    }
  }
  @keyframes slideIn {
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
}
.course-mooc {
  padding: 40px 0;
  box-sizing: border-box;
  height: 500px;
  box-sizing: border-box;
  width: 1240px;
  .container-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .main-title {
      color: #1c212a;
      font-family: 'Alibaba PuHuiTi';
      font-size: 32px;
      font-weight: 700;
      &::before {
        content: '';
        display: inline-block;
        width: 4px;
        height: 24px;
        background-color: #194189;
        margin-right: 8px;
      }
    }
  }
  .module-content {
    margin-top: 32px;
    display: flex;
    justify-content: center;
    .course-card-list {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 24px;
      .course-card {
        width: 199px;
        height: 248px;
        border-radius: 16px;
        background: #f7f8fa;
        padding: 20px;
        display: flex;
        cursor: pointer;
        transition: all 0.3s ease-in-out;
        &.active {
          width: 623px;
          background-color: #194189;
          .course-img {
            display: block;
          }
          .course-info {
            .course-name {
              color: #fff;
            }
            .teacher-name {
              color: #fff;
            }
            .orga-name {
              color: rgba(255, 255, 255, 0.6);
            }
            .btn {
              background-image: url('https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/494869a003dc4f3a94b72ff970738cd8.png');
            }
          }
        }
        .course-img {
          width: 370px;
          display: none;
          margin-right: 20px;
          img {
            width: 100%;
            height: 100%;
            object-fit: fill;
            border-radius: 16px;
          }
        }
        .course-info {
          flex: 1;
          .course-name {
            color: #1c212a;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            // 显示两行
            height: 44px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .teacher-name {
            color: #1c212a;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            margin-top: 16px;
            width: 100px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          .orga-name {
            color: #84909d;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            margin-top: 4px;
          }
          .btn {
            width: 28px;
            height: 28px;
            background-image: url('https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/a8446b0a36e9499a9a10553b10f9008f.png');
            background-size: 100% 100%;
            margin-top: 79px;
          }
        }
      }
      .no-data {
        width: 100%;
      }
    }
  }
}
</style>
